import { render, staticRenderFns } from "./WorkerCard.vue?vue&type=template&id=18b2ac2c&"
import script from "./WorkerCard.vue?vue&type=script&lang=js&"
export * from "./WorkerCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports